import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { CUSTOMIZACAO_RAIZEN } from '~/constants/modules';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteMotorista,
  findMotorista,
  recordFiltering,
} from '~/store/modules/motorista/actions';

import Form from './form';

function MotoristaList() {
  const redux = useSelector((state) => state.motorista);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idmotorista',
        label: t('s.cadastro.motorista.idmotorista'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemotorista',
        label: t('s.cadastro.motorista.nomemotorista'),
        filter: { type: 'text' },
      },
      {
        id: 'codigoauxiliarmotorista',
        label: t('s.configuracao.comboio.codigoauxiliarposto'),
        filter: { type: 'text' },
      },
      {
        id: 'statusmotorista',
        label: t('s.cadastro.motorista.statusmotorista'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  const fieldlist = [
    'idmotorista',
    'nomemotorista',
    'codigoauxiliarmotorista',
    'statusmotorista',
  ];

  const substituirHeader = {
    idmotorista: t('s.cadastro.motorista.idmotorista'),
    nomemotorista: t('s.cadastro.motorista.nomemotorista'),
    codigoauxiliarmotorista: t('s.configuracao.comboio.codigoauxiliarposto'),
    statusmotorista: t('s.cadastro.motorista.statusmotorista'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findMotorista}
      remove={deleteMotorista}
      form={Form}
      keys="idmotorista"
      detach="nomemotorista"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'motoristas',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Motoristas',
          substituirValores: {
            statusmotorista: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default MotoristaList;
